export default __webpack_public_path__ + "images/bedbe873e672085ecdaad5fd2a5f20ef.png";